var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"schedule"},_vm._l((_vm.schedule_pairs),function([d, val]){return _c('div',{key:d,staticClass:"day"},[_c('span',{staticClass:"day-label"},[_vm._v(_vm._s(_vm.shortDay(d)))]),_c('span',{class:[_vm.isClosed(val) ? 'text-orange' : 'time-bold']},[_vm._v(_vm._s(_vm.isClosed(val) ? 'вихідний' : val || '–'))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }